{
  "version": 1,
  "asset_id": "a0532039-78c9-4c56-b395-a64bb1284f44",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/a0532039-78c9-4c56-b395-a64bb1284f44/palworld-bp02-kv.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/a0532039-78c9-4c56-b395-a64bb1284f44/palworld-bp02-kv.webp",
  "original_filename": "palworld-bp02-kv.webp",
  "size": 81714,
  "content_type": "image/webp",
  "created_at": "2026-09-01T00:36:02Z"
}
